import service from "./service";

const prefix = "/pm";
// selection
export const apiGetListTenantConceptDropdown = (): Promise<
  API.DataResponse<API.filterOptionItem[]>
> => service.get(prefix + `/selection/km-proxy/concept-dropdown`);

export type TaskListByDomainAndModuleParams = {
  domainIds: Array<string | number>;
  moduleId: number;
  section?: string | null;
  processDefinitionId?: string | null;
  renderPerformPage?: boolean | null;
  /** reTaskIds that should resolve as latest (adopted / pending Reload) */
  reloadTaskIds?: string[];
};

export const getCustomTaskListByDomainAndModule = ({
  domainIds,
  moduleId,
  section,
  processDefinitionId,
  renderPerformPage,
  reloadTaskIds,
}: TaskListByDomainAndModuleParams): Promise<API.DataResponse<API.TaskOptionItem[]>> =>
  service.post(`${prefix}/task/list-by-condition`, {
    moduleId,
    domainIds,
    section: section ?? "",
    processDefinitionId: processDefinitionId ?? null,
    renderPerformPage: renderPerformPage ?? null,
    ...(reloadTaskIds?.length ? { reloadTaskIds } : {}),
  });

export const getTaskPropertyList = (params: {
  reTaskId: string;
}): Promise<API.DataResponse<API.TaskPropertyList>> =>
  service.get(`${prefix}/task-property/list/fields`, { params });

export const getTaskPropertyListV2 = (params: {
  reTaskId: string;
  processDefinitionId?: string;
}): Promise<API.DataResponse<API.TaskPropertyList>> =>
  service.get(`${prefix}/task-property/list/fields/v2`, { params });

export const getTaskFlowPropertyList = (params: {
  reTaskId: string;
  processDefinitionId?: string;
}): Promise<API.DataResponse<API.TaskFlowPropertyList>> =>
  service.get(`${prefix}/task/flow/properties`, { params });

export const getTaskPageList = (): Promise<
  API.DataResponse<API.TaskPageListItem[]>
> => service.get(`${prefix}/task/list`);

export const getSystemTaskList = (): Promise<
  API.DataResponse<API.SystemTaskListItem[]>
> => service.get(`${prefix}/system-task/list-all`);

export const getSystemTaskListByDomainAndModule = ({
  domainIds,
  moduleId,
  section,
  processDefinitionId,
  reloadTaskIds,
}: TaskListByDomainAndModuleParams): Promise<API.DataResponse<API.TaskOptionItem[]>> =>
  service.post(`${prefix}/system-task/list-by-condition`, {
    domainIds,
    moduleId,
    section,
    ...(processDefinitionId ? { processDefinitionId } : {}),
    ...(reloadTaskIds?.length ? { reloadTaskIds } : {}),
  });

export const getEventTemplateOptions = (params: {
  moduleId?: string;
  section?: string;
}): Promise<API.DataResponse<API.OptionItem[]>> =>
  service.post(`${prefix}/selection/event-proxy/event-dropdown`, params);

export const getModuleLifecycleConceptOptions = (params: {
  moduleId?: string;
  section?: string;
}): Promise<API.DataResponse<API.OptionItem[]>> =>
  service.post(
    `${prefix}/selection/km-proxy/concept-dropdown/v2`,
    params
  );

export const getModuleLifecycleStageOptions = (params: {
  moduleId?: string;
  section?: string;
  concept?: string;
}): Promise<API.DataResponse<API.OptionItem[]>> =>
  service.post(`${prefix}/selection/km-proxy/concept-value-dropdown`, params);

export const getTaskDomainOptions = (params: {
  moduleId: string;
}): Promise<API.DataResponse<API.OptionItem[]>> =>
  service.get(`${prefix}/selection/task-domain-dropdown`, { params });

export const getModuleSectionOptions = (params: {
  moduleId: string;
}): Promise<API.DataResponse<API.OptionItem[]>> =>
  service.post(`${prefix}/selection/module/section-dropdown`, params);

export const getModuleDynamicViewOptions = (params: {
  moduleId: string;
}): Promise<API.DataResponse<API.OptionItem[]>> =>
  service.get(`${prefix}/selection/dynamic-view`, { params });

export const getTaskRecordSourceOptions = (): Promise<
  API.DataResponse<API.OptionItem[]>
> => service.get(`${prefix}/selection/task-record-source`);

export const saveTaskRepositoryV2 = (
  data: API.TaskRepositoryV2Req
): Promise<API.DataResponse<null>> =>
  service.post(`${prefix}/task/repository/v2`, data);

export const createSystemTask = (
  data: API.SystemTaskReq
): Promise<API.DataResponse<null>> =>
  service.post(`${prefix}/system-task`, data);

export const updateTaskRepositoryV2 = (
data: API.TaskRepositoryV2Req
): Promise<API.DataResponse<null>> =>
service.put(`${prefix}/task/repository/v2`, data);

export const updateSystemTask = (
  data: API.SystemTaskReq & { id: string | number }
): Promise<API.DataResponse<null>> =>
  service.put(`${prefix}/system-task`, data);

export const getTaskInfoRspByIdV2 = (
id: string
): Promise<API.DataResponse<API.TaskDetail>> =>
service.get(`${prefix}/task/${id}/v2`);

export const getSystemTaskInfoById = (
  id: string
): Promise<API.DataResponse<API.SystemTaskDetail>> =>
  service.get(`${prefix}/system-task/${id}`);

export const getTaskModuleOptions = (): Promise<
  API.DataResponse<API.OptionItem[]>
> => service.get(`${prefix}/selection/task-module-dropdown`);

/** POST /selection/process/dropdown/by-condition — requires domainIds + moduleId */
export const listTemplateDropdownByCondition = (params: {
  domainIds: number[];
  moduleId: number;
}): Promise<API.DataResponse<API.OptionItem[]>> =>
  service.post(`${prefix}/selection/process/dropdown/by-condition`, params);

export const updateTask = (
  data: API.TaskFormVO
): Promise<API.DataResponse<number>> =>
  service.put(`${prefix}/task/repository`, data);

export const updateTaskConfig = (
  data: API.TaskConfigFormVO
): Promise<API.DataResponse<number>> =>
  service.put(`${prefix}/task/config`, data);

export const getTaskPropertyPageList = (
  taskId: string
): Promise<API.DataResponse<API.TaskPropertyData>> =>
  service.get(`${prefix}/task-property/list/${taskId}/v2`);

export const updateTaskPropertyOrder = (
  propertyId: string | number,
  orderIndex: number
): Promise<API.DataResponse<number>> =>
  service.put(
    `${prefix}/task-property/${propertyId}/order-index/${orderIndex}`
  );

export const updateTaskProperty = (
  data: API.TaskPropertyFormVO
): Promise<API.DataResponse<number>> =>
  service.put(`${prefix}/task-property`, data);

export const saveTemplateDetails = (
  params: API.TemplateManagerVO
): Promise<API.DataResponse<string>> =>
  service.post(`${prefix}/process-template`, { ...params });

export const updateTemplateDetails = (
  params: API.TemplateManagerVO
): Promise<API.DataResponse<boolean>> =>
  service.put(`${prefix}/process-template`, { ...params });

export const getTemplateList = (): Promise<
  API.DataResponse<API.TeamplateListItem[]>
> => service.get(`${prefix}/process-template/list`);

export const getTemplateById = (
  id: string
): Promise<API.DataResponse<API.TemplateManagerVO>> =>
  service.get(`${prefix}/process-template/details/${id}`);

export const getTaskPropertyCondition = (params: {
  reTaskId: string;
  processDefinitionId?: string;
}): Promise<API.DataResponse<API.TaskPropertyList>> =>
  service.get(`${prefix}/task-property/list/conditions`, { params });

export const deployTemplate = (params: any): Promise<API.DataResponse<any>> =>
  service.post(`${prefix}/process/definition/deploy`, params);

export const getTemplateBPMNById = (
  templateId: string
): Promise<API.DataResponse<API.TemplateBPMNDetails>> =>
  service.get(`${prefix}/process-template/process-definition/${templateId}`);

// selection - task owners (users, groups, roles) for CC recipients
export const getTaskOwnersSelection = (): Promise<
  API.DataResponse<API.TaskOwnersSelection>
> => service.get(`${prefix}/selection/task-owners`);

// version history
export const getTemplateVersionHistoryList = (
  params: { templateId: string }
): Promise<API.DataResponse<API.TemplateVersionHistoryItem[]>> =>
  service.get(`${prefix}/process-template/history/version/list`, { params });

export const getDefinitionByProcessDefinitionId = (
  processDefinitionId: string
): Promise<API.DataResponse<API.TemplateBPMNDetails>> =>
  service.get(
    `${prefix}/process-template/details/definition/${processDefinitionId}`
  );

export const getConditionNodeStatusList = (
): Promise<API.DataResponse<Record<string, string>[]>> =>
  service.get(`${prefix}/process-template/condition-node/status/dropdown`);

export const getCallActivityProperty = (data: {
  moduleId: string;
}): Promise<API.DataResponse<{ fields: any[] }>> =>
  service.post(
    `${prefix}/process-template/call-activity/definition/property`,
    data
  );

export const getUserTaskSystemPropertyList = (): Promise<
  API.DataResponse<Array<string>>
> => service.get(`${prefix}/task/system-property/list`);

export const fetchModuleListByDomainIds = (
  domainIds: string[]
): Promise<API.DataResponse<API.OptionItem[]>> =>
  service.get(`${prefix}/selection/module?domainIds=${domainIds}`);

export const getTaskSectionListByModule = (
  moduleId: string
): Promise<API.DataResponse<API.ModuleSectionOption[]>> =>
  service.get(`${prefix}/selection/task-section/${moduleId}`);

export const getTaskPropertyById = (
  propertyId: string
): Promise<API.DataResponse<API.TaskPropertyItem>> =>
  service.get(`${prefix}/task-property/${propertyId}`);

export const updateTaskPropertyJson = (
  propertyId: string,
  data: API.TaskPropertyItem
): Promise<API.DataResponse<API.TaskPropertyItem>> =>
  service.put(`${prefix}/task-property/${propertyId}`, data);

export const createTaskPropertyJson = (
  data: API.TaskPropertyItem
): Promise<API.DataResponse<API.TaskPropertyItem>> =>
  service.post(`${prefix}/task-property`, data);

export const getTemplatePrivilegeList = (): Promise<
  API.DataResponse<Array<string>>
> => service.get(`${prefix}/selection/process/dropdown`);

export const getTemplateDomainPrivilegeList = (
  templateId: string,
): Promise<
  API.DataResponse<Array<string>>
> => service.get(`${prefix}/selection/process/${templateId}/domain-dropdown`);

export const getTemplateActionPrivilegeList = (): Promise<
  API.DataResponse<Array<string>>
> => service.get(`${prefix}/selection/process/operate-dropdown`);

export const fetchDomainListByTenant = (
  tenantId: string
): Promise<API.DataResponse<API.ModuleDomainDetail[]>> =>
  service.get(`${prefix}/selection/${tenantId}/domain/dropdown`);


export const deleteTaskProperty = (
  propertyId: string | number
): Promise<API.DataResponse<boolean>> =>
  service.delete(`${prefix}/task-property/${propertyId}`);

export const apiGetFeatureFlagListAll = (): Promise<
  API.DataResponse<Record<string, string | boolean | string[]>>
> => service.get(`${prefix}/feature/flags/list-all`);